import { TranslateLoader } from '@ngx-translate/core'
import { defer, Observable } from 'rxjs'
import { concatMap } from 'rxjs/operators'
import { HttpClient } from '@angular/common/http'
import { getDownloadURL, ref, Storage } from '@angular/fire/storage'

export class TranslateFirebaseLoader implements TranslateLoader {
	constructor(
		private readonly storage: Storage,
		private readonly http: HttpClient,
		private readonly path: string,
	) {}

	public getTranslation(lang: string): Observable<any> {
		const storageRef = ref(this.storage, `${this.path}/${lang}.json`)
		return defer(() => getDownloadURL(storageRef)).pipe(concatMap((url: string) => this.http.get<any>(url)))
	}
}
